(() => {
  if (window.kissImageFitStarted) return;
  window.kissImageFitStarted = true;
  const selector = 'product-card .card-gallery .product-media[data-media-id], media-gallery .product-media[data-media-id]:not(.dialog-zoomed-gallery *)';
  const script = document.querySelector('script[data-kiss-image-fit]');
  if (!script?.dataset.mapUrl) return;
  let map = {}, active = false, frame = 0;
  const seen = new WeakSet(), pending = new Set();

  function measure(stage) {
    if (!stage.isConnected) return;
    let meta = map[stage.dataset.mediaId];
    const img = stage.querySelector('img.product-media__image');
    if (!img) return;
    if (!meta) { if (!img.naturalWidth) return; meta = [img.naturalWidth,img.naturalHeight,0,0,1,1]; }
    const [iw, ih, x0, y0, x1, y1, edgeToEdge = false] = meta;
    const w = stage.clientWidth, h = stage.clientHeight;
    if (w < 40 || h < 40) return;
    const pad = edgeToEdge ? 0 : Math.max(6, Math.min(10, w * .03));
    const bw = x1 - x0, bh = y1 - y0;
    const scale = Math.min((w - 2 * pad) / (iw * bw), (h - 2 * pad) / (ih * bh));
    const dw = iw * scale, dh = ih * scale;
    return {stage,img,x0,y0,x1,y1,dw,dh,left:(w-dw*bw)/2-dw*x0,top:(h-dh*bh)/2-dh*y0};
  }

  function flush() {
    frame = 0;
    // Read all dimensions first; alternating reads/writes forces repeated layout.
    const measurements = Array.from(pending, measure).filter(Boolean);
    pending.clear();
    for (const {stage,img,x0,y0,x1,y1,dw,dh,left,top} of measurements) {
      const requestedSize = `${Math.ceil(dw)}px`;
      if (img.sizes !== requestedSize) img.sizes = requestedSize;
      stage.dataset.kissFit = 'ready';
      img.style.clipPath = `inset(${(y0*100).toFixed(4)}% ${((1-x1)*100).toFixed(4)}% ${((1-y1)*100).toFixed(4)}% ${(x0*100).toFixed(4)}%)`;
      img.dataset.kissFitVersion = '2026-10-21-square';
      stage.style.setProperty('--kiss-photo-width', `${dw.toFixed(2)}px`);
      stage.style.setProperty('--kiss-photo-height', `${dh.toFixed(2)}px`);
      stage.style.setProperty('--kiss-photo-left', `${left.toFixed(2)}px`);
      stage.style.setProperty('--kiss-photo-top', `${top.toFixed(2)}px`);
    }
  }

  function queue(stage) {
    if (!active) return;
    pending.add(stage);
    if (!frame) frame = requestAnimationFrame(flush);
  }
  const resize = new ResizeObserver(entries => entries.forEach(entry => queue(entry.target)));
  function register(stage) {
    queue(stage);
    if (seen.has(stage)) return;
    seen.add(stage);
    resize.observe(stage);
    stage.addEventListener('load', () => queue(stage), true);
  }
  function scan(root = document) {
    if (!active || !root.querySelectorAll) return;
    if (root instanceof Element) {
      const parentStage = root.closest(selector);
      if (parentStage) register(parentStage);
    }
    root.querySelectorAll(selector).forEach(register);
  }
  const changes = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
      for (const node of record.removedNodes) {
        if (node.nodeType !== 1 || node.isConnected) continue;
        if (node.matches(selector)) resize.unobserve(node);
        node.querySelectorAll(selector).forEach(stage => resize.unobserve(stage));
      }
    }
  });
  fetch(script.dataset.mapUrl, {credentials:'same-origin'})
    .then(r => { if (!r.ok) throw new Error('Image fit map unavailable'); return r.json(); })
    .then(data => {
      map = data; active = true; scan();
      const root = document.getElementById('MainContent');
      if (root) changes.observe(root, {childList:true, subtree:true});
      document.addEventListener('shopify:section:load', event => scan(event.target));
    })
    .catch(() => { /* Original contain layout remains fully usable. */ });
})();


